// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const engagementSummaryQuery = gql`
  query EngagementSummary(
    $organizationId: ID!
    $projectId: ID
    $foundationId: ID
    $isAllOrgs: Boolean
  ) {
    engagementSummary(
      organizationId: $organizationId
      projectId: $projectId
      foundationId: $foundationId
      isAllOrgs: $isAllOrgs
    ) {
      code
      message
      engagementSummary {
        trainingAndCertifications {
          courseId
          courseName
          enrollmentCount
          courseLink
        }
        engagementAndTeam {
          accountId
          projectId
          year
          month
          quarter
          eventRegistrationCount
          commitCount
          contributorsCount
          maintainersCount
          enrollmentsCount
          certificationsCount
          committeeMembersCount
          keyContactsCount
          sponsorshipEventReachedCount
          meetingsMinuteCount
          subscribersCount
        }
        upcomingEvents {
          eventId
          eventName
          eventStartDate
          eventEndDate
          eventIsPast
          eventUrl
          eventCity
          eventCountry
          totalRegistrants
          myOrgRegistrants
          totalSpeakerProposals
          acceptedSpeakerProposals
        }
        myOrgVsTopContributingOrgs {
          accountName
          commitCountAllTime
        }
      }
    }
  }
`;
